var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select2-multiple-control',{attrs:{"id":_vm.id,"value":_vm.value,"options":_vm.options,"required":_vm.required,"disabled":_vm.disabled,"settings":_vm.comboSettings,"placeholder":_vm.placeholder},on:{"change":_vm.update,"select":_vm.optionSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }